import { Redirect, Route } from "react-router";
import React, { useContext } from "react";
import { UserContext } from "../../utils/UserContext";

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useContext(UserContext);
  return (
    <Route
      {...rest}
      render={(props) =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/bejelentkezes",
            }}
          />
        )
      }
    />
  );
};
